<template>
  <span>
    <v-dialog v-model="visible" max-width="65%">
      <v-card>
        <v-card-title class="text-h6 grey lighten-1">
          <v-icon class="ml-n2 mr-4 pa-2" style="background: rgba(10,30,30,.1); box-shadow: 2px 2px 5px; border-radius: 5px;">mdi-file-outline</v-icon>
          Impresión recibo de cobro
        </v-card-title>

        <v-card-text class="pa-0">
          <v-data-table
            v-model="seleccion"
            :headers="cabeceras"
            :items="arrayCobros"
            :loading="cargando"
            :search="busqueda"
            item-key="cod"
            dense
            single-select
            @click:row="tablaCobrosClickRow"
            @current-items="tablaCobrosCurrentItems"
            @dblclick:row="tablaCobrosDblClickRow"
          >
            <template v-slot:top>
              <v-container style="background: #dcdcd0;" class="px-0">
                <v-text-field
                  ref="busqueda"
                  style="width: 280px"
                  append-icon="mdi-magnify"
                  v-model="busqueda"
                  label="Buscar cobro"
                  class="mx-4"
                  hide-details
                  @keypress.enter="tablaCobrosDblClickRow"
                ></v-text-field>
              </v-container>
            </template>

            <template v-slot:[`item.fechor`] = "{ item }">
              {{ formatearFechaHora (item.fechor) }}
            </template>
            <template v-slot:[`item.numpro`]="{ item }">
              <span class="numero-producto">{{ item.numpro }}</span>
            </template>
            <template v-slot:[`item.mat`]="{ item }">
              <template v-if="item.mat">
                <span class="matricula">{{ item.mat }}</span>
              </template>
            </template>
            <template v-slot:[`item.imptot`] = "{ item }">
              {{ $utilI18N.cadenaImporte (item.imptot)}}
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="green darken-2" :disabled="seleccion.length==0" @click="botonSiguienteClick">
            {{ $t ('Siguiente') }}
          </v-btn>
          <v-btn text @click="botonCancelarClick">
            {{ $t ('Cancelar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <VentanaVisorRecibos ref="vvr" />
  </span>
</template>

<script>
import VentanaVisorRecibos from "@/components/VentanaVisorRecibos";
import { DateTime } from "luxon";

export default {
  components: {
    VentanaVisorRecibos,
  },
  data () {
    return {
      cabeceras: [
        { text: this.$t ("Fecha/Hora cobro"), value: "fechor" },
        { text: this.$t ("Aparato"), value: "nomlarapa" },
        { text: this.$t ("Concepto"), value: "descondetcob" },
        { text: this.$t ("Grupo productos"), value: "desgrupro" },
        { text: this.$t ("Núm. producto"), value: "numpro" },
        { text: this.$t ("Matrícula"), value: "mat" },
        { text: this.$t ("Importe"), value: "imptot", align: "end" }
      ],

      objetoAparato: {},
      sagabroker: null,

      visible: false,
      cargando: false,
      arrayCobros: [],
      busqueda: '',
      seleccion: []
    }
  },
  methods: {
    abrirVentana (objetoAparato, sagabroker) {
      this.objetoAparato = objetoAparato;
      this.sagabroker = sagabroker;

      this.seleccion = [];
      this.busqueda = '';
      this.arrayCobros = [];

      this.visible = true;
      this.cargando = true;

      this.sagabroker.solicitarUltimosCobrosAparcamiento (this.objetoAparato.id_ins)
        .then ((mensaje) => {
          this.arrayCobros = mensaje.contenido.cobros;
        })
        .catch(() => {
          alert ('ERROR: Timeout obteniendo los últimos cobros del aparcamiento');
          this.visible = false;
        })
        .finally(() => {
          this.cargando = false;
        });

      // establecemos el foco en el campo de busqueda
      setTimeout (() => {
        this.$refs['busqueda'].focus();
      }, 250);
    },
    formatearFechaHora (fechaHoraISO) {
      if (fechaHoraISO != null)
        return DateTime.fromISO (fechaHoraISO).toFormat('dd-MM-yyyy HH:mm');
      else
        return "-";
    },
    botonSiguienteClick () {
      this.sagabroker.solicitarReciboCobro (this.objetoAparato.id_ins, this.seleccion[0].cod)
        .then ((mensaje) => {
          mensaje.contenido.recibo = mensaje.contenido.recibo.replace (/{.+}/g, "");
          let visorRecibos = this.$refs ['vvr'];
          visorRecibos.abrirVentana ('Recibo de cobro', mensaje.contenido.recibo)
            .then (() => {
              this.sagabroker.ejecutarAccionAparato (this.objetoAparato.id_ins, this.$store.operador.correoElectronico, this.objetoAparato.id_tipapa, this.objetoAparato.num, 'imprimir_recibo_cobro', { codigo_cobro: this.seleccion[0].cod } );
            })
            .catch (() => {

            });
        })
        .catch (() => {
          alert ('ERROR: Timeout obteniendo el recibo de cobro');
        });
      this.visible = false;
    },
    botonCancelarClick () {
      this.visible = false;
    },
    tablaCobrosClickRow (fila) {
      this.seleccion = [fila];
    },
    tablaCobrosCurrentItems (filas) {
      if (filas.length == 1)
        this.seleccion = filas;
      else
        this.seleccion = [];
    },
    tablaCobrosDblClickRow () {
      if (this.seleccion.length == 1)
        this.botonSiguienteClick ();
    }

  }
}
</script>

<style scoped>
.numero-producto {
  font-family: monospace;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: -0.3px;
}
.matricula {
  font-family: monospace;
  font-weight: 600;
  padding: 1px 4px 1px 4px;
  border: 1px #A0A0A0 solid;
  border-radius: 5px;
  background: #F4F4F4
}
</style>